import React from 'react';

import { ColorsType, variables } from '../variables';

type ArrowLeftProps = {
  stroke?: ColorsType
}

export  const ArrowLeft: React.FC<ArrowLeftProps> = ({
 stroke= 'road-grey-700'
}) => {
  return (
    <svg width="6" height="10" viewBox="0 0 6 10" fill="none" stroke={variables.colors[stroke]} xmlns="http://www.w3.org/2000/svg">
      <path d="M5.44752 9.3775L1.1618 5.09179L5.44752 0.806076" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}
